import React from 'react';
import cobranzasService from '../services/cobranzasService';

const AlertaCobranza = ({ cobranzaStatus, onOpenUploadModal }) => {
    if (!cobranzaStatus) return null;

    const { status, due_day, monthly_amount, latest_receipt, global_config } = cobranzaStatus;

    if (status === 'ACTIVE' || status === 'EXEMPT') {
        return null;
    }

    const title = global_config?.title || 'Aviso de Pago Mensual';
    const rawImageUrl = global_config?.payment_image_url || cobranzaStatus?.payment_image_url;
    const paymentImageUrl = cobranzasService.getMediaUrl(rawImageUrl);

    if (status === 'PENDING_PAYMENT') {
        return (
            <div style={{
                background: 'linear-gradient(90deg, #fffbeb 0%, #fef3c7 100%)',
                borderBottom: '1px solid #fde68a',
                color: '#92400e',
                padding: '0.75rem 1.5rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: '0.75rem',
                fontSize: '0.9rem',
                boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
                zIndex: 900
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap' }}>
                    <span style={{
                        background: '#f59e0b',
                        color: '#fff',
                        borderRadius: '50%',
                        width: '24px',
                        height: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.8rem',
                        fontWeight: 'bold',
                        flexShrink: 0
                    }}>
                        !
                    </span>
                    <span>
                        <strong>{title}:</strong> Recuerda que la fecha límite para reportar tu mensualidad (${monthly_amount} USD) es el <strong>día {due_day} de este mes</strong>.
                    </span>
                </div>
                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                    <button
                        onClick={onOpenUploadModal}
                        style={{
                            background: '#d97706',
                            color: '#ffffff',
                            border: 'none',
                            padding: '0.45rem 1.1rem',
                            borderRadius: '6px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            fontSize: '0.85rem',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            transition: 'background 0.2s',
                            boxShadow: '0 2px 4px rgba(217, 119, 6, 0.2)'
                        }}
                        onMouseEnter={(e) => e.target.style.background = '#b45309'}
                        onMouseLeave={(e) => e.target.style.background = '#d97706'}
                    >
                        <i className="bi bi-credit-card-2-front-fill"></i>
                        Ver Cuenta y Pagar / Subir Comprobante
                    </button>
                </div>
            </div>
        );
    }

    if (status === 'UNDER_REVIEW') {
        return (
            <div style={{
                background: 'linear-gradient(90deg, #f0f9ff 0%, #e0f2fe 100%)',
                borderBottom: '1px solid #bae6fd',
                color: '#0369a1',
                padding: '0.65rem 1.5rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: '0.75rem',
                fontSize: '0.875rem',
                zIndex: 900
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                    <i className="bi bi-clock-history" style={{ fontSize: '1.1rem', color: '#0284c7' }}></i>
                    <span>
                        <strong>Comprobante en Revisión:</strong> Hemos recibido tu comprobante
                        {latest_receipt?.extracted_amount ? ` (detectado: $${latest_receipt.extracted_amount} USD)` : ''}.
                        Tu acceso está <strong>habilitado temporalmente</strong> mientras es auditado por el Gestor de Cobranzas.
                    </span>
                </div>
                <button
                    onClick={onOpenUploadModal}
                    style={{
                        background: 'transparent',
                        color: '#0284c7',
                        border: '1px solid #7dd3fc',
                        padding: '0.3rem 0.8rem',
                        borderRadius: '6px',
                        fontWeight: '500',
                        cursor: 'pointer',
                        fontSize: '0.8rem',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.4rem'
                    }}
                >
                    <i className="bi bi-arrow-repeat"></i> Cambiar Comprobante
                </button>
            </div>
        );
    }

    return null;
};

export default AlertaCobranza;
